import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSnackBar, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { firstValueFrom, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { BlockUI, NgBlockUI, BlockUIModule } from 'ng-block-ui';
import { BlockTemplateComponent } from 'src/app/@theme/@components';
import { Store } from '@ngrx/store';
import { AppState } from './../../../@store/app.reducers';
import { ActivarLoadingAction, DesactivarLoadingAction } from './../../../@store/actions/ui.actions';
import { AuthService } from './../../../services/auth/auth.service';
import { ActualizaDatosService } from './../../../services/auth/actualiza-datos/actualiza-datos.service';
import Swal from 'sweetalert2';
import { DesbloqueaUsuarioService } from 'src/app/services/auth/desbloquea-usuario/desbloquea-usuario.service';
import { IResponse2FA } from 'src/app/models/account/account.model';
import { HttpErrorResponse } from '@angular/common/http';
import { CommonModule, NgClass } from '@angular/common';
import { MatFormField, MatSuffix, MatError, MatHint, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatIconButton, MatButton, MatAnchor } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatSelect, MatOption } from '@angular/material/select';

interface IRespuestaObjeto {
  Exito: boolean;
  TextoUsuario: string | null;
  TextoSistema: string | null;
  Respuesta: string[];
}

interface IErrorResponse {
  headers: {
    normalizedNames: any;
    lazyUpdate: any;
  };
  status: number;
  statusText: string;
  url: string;
  ok: boolean;
  name: string;
  message: string;
  error: {
    Exito: boolean;
    TextoUsuario: string;
    TextoSistema: string | null;
    Respuesta: any[] | null;
  };
}

interface IResponseValidaContrasena {
  datos: Validacion[];
  validacion: boolean;
  errorDescripcion: string;
}

interface Validacion {
  IdValidacion: number;
  Descripcion: string;
}
@Component({
    selector: 'app-snackbar-actualiza-datos',
    template: `
    <div class="text-small" [innerHTML]="data.html"></div>
  `,
    styles: ['.text-small {font-size : 12px !important}'],
    standalone: false
})
export class SnackbarComponent {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any,
    public snackBar: MatSnackBar) {
  }
}
@Component({
    selector: 'app-desbloquea-usuario',
    templateUrl: './desbloquea-usuario.component.html',
    styleUrls: ['./desbloquea-usuario.component.scss'],
    imports: [ CommonModule, BlockUIModule, FormsModule, ReactiveFormsModule, MatFormField, MatInput, MatIconButton, MatSuffix, MatIcon, MatError, MatButton, MatAnchor, RouterLink, NgClass, MatHint, MatLabel, MatSelect, MatOption]
})
export class DesbloqueaUsuarioComponent implements OnInit, OnDestroy {
  @BlockUI() blockUI?: NgBlockUI | any;
  public blockTemplate = BlockTemplateComponent;
  public subsReduxUI = new Subscription();
  public template: string = 'corporativo';
  public seccionA: boolean = true;
  public formPregunta: FormGroup;
  public formDesbloqueaUsuario: FormGroup;
  public hide1 = true;
  public hide2 = true;
  public hide3 = true;
  public hide4 = true;
  public catPreguntas: any;
  public imagen: string;
  public loading = false;
  public urlData: string;
  public usuarioPrevio: string;
  public preguntaSecreta: string;
  public respuestaSecreta: string;
  public mensajeSeccionA: string;
  public generaErrorPasswordForm = false;
  public valGuardar = false;
  public Cuenta: any;

  public formularioCargado = false;
  private passwordSubscription: Subscription;
  public esExcepcion: boolean = true;
  public jsonCode: any;
  public msgError = '';
  public timer: any;
  public intervalo: number = 0;
  public maskedEmail: string = '';
  public maskedPhone: string = '';
  public tiempoBloqueo: number = 0;
  public contadorIntentos: number = 0;
  public intentos: number = 0;

  constructor(
    private store: Store<AppState>,
    private snackBar: MatSnackBar,
    private authService: AuthService,
    private actDatosService: ActualizaDatosService,
    private desbloqueaUsuarioService: DesbloqueaUsuarioService,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  public ngOnInit(): void {
    this.subsReduxUI = this.store.select('ui').subscribe(data => {
      if (data.block.isLoading !== null && data.block.isLoading !== undefined) {
        data.block.isLoading ? (this.blockUI.isActive ? null : this.blockUI.start(data.block.message || 'Cargando...')) : this.blockUI.stop();
      }
    });
    this.route.paramMap.subscribe(params => {
      this.urlData = params.get('data');
    });

    this.cargarData();
    this.imagenAleatoria();

    // this.formDesbloqueaUsuario.get('password').valueChanges.pipe(debounceTime(2000), distinctUntilChanged()).subscribe((pass: string) => {
    //   if (pass.length > 0) this.validarContrasena(pass);
    // });

    // this.formPregunta.valueChanges.subscribe(changes => {
    //   console.log('Se detectaron cambios en el formulario:', changes);
    //   // Aquí puedes realizar cualquier acción que necesites cuando haya cambios en el formulario
    // });
  }

  public ngOnDestroy(): void { }

  public cargarData() {
    this.store.dispatch(ActivarLoadingAction());

    const jsonParam = {
      Data: this.urlData
    }

    this.authService.desencriptaData(jsonParam).subscribe({
      next: async (resp: IRespuestaObjeto) => {
        if (!resp.Exito) return;

        const usuarioData = resp.Respuesta.find(item => item.startsWith("usuario:"));
        if (!usuarioData) {
          this.mostrarError("No pudimos cargar el tipo de cuenta");
          return;
        }

        const usuario = usuarioData.split(":")[1];

        try {
          //const excepcion = await this.validarExcepcion(usuario) as IResponse2FA;
          let excepcion: IResponse2FA;
          excepcion = await firstValueFrom(this.authService.validaExcepcionDesbloqueo(usuario));
          if (excepcion?.validacion) {
            this.esExcepcion = excepcion.datos.isExcepcion2FA;
            this.cargarFormularioUsuario(this.esExcepcion);
            this.formularioCargado = true;

            this.esExcepcion
              ? await this.procesoPregunta(resp)
              : await this.procesoCodigo(resp);
          }

          this.store.dispatch(DesactivarLoadingAction());
        } catch (error) {
          this.store.dispatch(DesactivarLoadingAction());
          this.mostrarError("Ups ocurrió algo mientras consultábamos los datos");
        }
      },
      error: (error: IErrorResponse) => {
        this.store.dispatch(DesactivarLoadingAction());
        Swal.fire({
          icon: 'error',
          title: error.error.TextoUsuario,
        }).then(() => {
          this.router.navigate(['/login']);
        });
      }
    });
  }

  public async cargarCuenta(): Promise<any> {
    try {
      const resp = await this.authService.tipoCuenta(this.usuarioPrevio).toPromise();
      if (resp) {
        this.Cuenta = Object.assign(resp);
      }
      return resp;
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: "No pudimos cargar el tipo de cuenta"
      });
    }
  }

  public async cargarCatalogos(): Promise<any> {
    try {
      const jsonParam = {
        usuario: this.usuarioPrevio
      }
      const resp: IRespuestaObjeto = await this.authService.obtenerPreguntasSecretas(jsonParam).toPromise();
      if (resp) {
        this.catPreguntas = Object.assign(resp.Respuesta);
      }
      return resp;
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: "Ups! No pudimos cargar el catálogo de preguntas"
      });
    }
  }

  cargarFormularioUsuario(esExcepcion: boolean): void {
    this.formPregunta = esExcepcion
      ? this.buildFormPreguntaConExcepcion()
      : this.buildFormPreguntaSinExcepcion();

    this.formDesbloqueaUsuario = esExcepcion
      ? this.buildFormDesbloqueaConExcepcion()
      : this.buildFormDesbloqueaSinExcepcion();

    this.formDesbloqueaUsuario.controls['password2'].setValidators([
      Validators.required,
      this.noIgual.bind(this.formDesbloqueaUsuario)
    ]);

    // Limpiar suscripción anterior
    if (this.passwordSubscription) {
      this.passwordSubscription.unsubscribe();
    }

    // Nueva suscripción segura
    this.passwordSubscription = this.formDesbloqueaUsuario.get('password').valueChanges
      .pipe(debounceTime(2000), distinctUntilChanged())
      .subscribe((pass: string) => {
        if (pass?.length > 0) {
          this.validarContrasena(pass);
        }
      });
  }

  validarPreguta() {
    if (this.formPregunta.invalid) {
      return;
    }

    this.store.dispatch(ActivarLoadingAction());

    const jsonParam = {
      ...this.formPregunta.getRawValue()
    }

    this.authService.validarPregunta(jsonParam).subscribe((resp: IRespuestaObjeto) => {
      if (resp.Exito) {
        this.seccionA = false;
      }
    }, (error: IErrorResponse) => {
      Swal.fire({
        icon: 'error',
        title: error.error.TextoUsuario,
      }).then(() => {
        this.formPregunta.get('respuesta').setValue('');
        this.mensajeSeccionA = error.error.Respuesta["Mensaje"];
        this.store.dispatch(DesactivarLoadingAction());
      });
    }, () => {
      this.store.dispatch(DesactivarLoadingAction());
    });
  }

  actualizarDatos() {
    if (this.formDesbloqueaUsuario.invalid) return;
    this.store.dispatch(ActivarLoadingAction());
    const { password2, ...request } = this.formDesbloqueaUsuario.getRawValue();
    this.desbloqueaUsuarioService.postReactivaCuenta(request).subscribe((resp: IRespuestaObjeto) => {
      this.store.dispatch(DesactivarLoadingAction());
      if (resp.Exito) {
        Swal.fire({ icon: 'success', title: `${resp.TextoUsuario}` });
        this.router.navigate(['/login']);
      }
      else {
        Swal.fire({ icon: 'error', title: `${resp.TextoUsuario}` });
      }
    }, (err: IErrorResponse) => {
      this.store.dispatch(DesactivarLoadingAction());
      Swal.fire({ icon: 'error', title: `${err.error.TextoUsuario}` });
    });
  }

  validarContrasena(password: string) {
    this.store.dispatch(ActivarLoadingAction());
    const request = {
      password,
      usuario: (this.formDesbloqueaUsuario.get("usuario").value) ? this.formDesbloqueaUsuario.get("usuario").value : ""
    }
    this.actDatosService.postValidaContrasena(request).subscribe((resp: IResponseValidaContrasena) => {
      this.store.dispatch(DesactivarLoadingAction());
      let msgError = '';
      if (resp?.datos.length > 0) {
        this.generaErrorPasswordForm = true;
        this.valGuardar = false;
        resp.datos.forEach((element) => {
          msgError += `<li> ${element.Descripcion} </li> <br>`;
        });
        this.abrirSnackBar(msgError, `Contraseña`, 'exitoSnackbar');
      } else {
        this.generaErrorPasswordForm = false;
        this.valGuardar = true;
      }
    }, error => {
      this.store.dispatch(DesactivarLoadingAction());
      let msgError = '';
      if (error?.error) {
        if (error.error.length > 0) {
          this.generaErrorPasswordForm = false;
          this.valGuardar = false;
          error.error.forEach((element, index) => {
            if (element.Visible) msgError = index === 0 ? element.Exception : `${msgError} ${element.Exception}`;
          });
        }
        else {
          this.generaErrorPasswordForm = false;
          this.valGuardar = false;
          msgError = error?.error?.Exception;
        }
      }
      this.abrirSnackBar(msgError, `Contraseña`, 'errorSnackbar');
    });
  }

  private abrirSnackBar(mensaje: string, titulo: string, clase: string) {
    this.snackBar.openFromComponent(SnackbarComponent, {
      duration: 5000,
      panelClass: clase,
      data: {
        html: mensaje
      }
    })
  }

  noIgual(form: FormControl): { [s: string]: boolean } {
    let formLocal: any = this;
    if (form.value !== formLocal.controls['password'].value) {
      return { noIgual: true }
    }
    return null;
  }

  imagenAleatoria() {
    this.imagen = `assets/img/${Math.floor((Math.random() * Math.floor(5)) + 1)}.jpg`;
    setTimeout(() => {
      this.imagenAleatoria();
    }, 30000);
  }
  validarFormulario() {
    if (this.valGuardar) {
      if (!this.formDesbloqueaUsuario.invalid)
        return false;
      else
        return true;
    }
    return true;
  }

  private buildFormPreguntaConExcepcion(): FormGroup {
    return new FormGroup({
      usuario: new FormControl('', Validators.required),
      respuesta: new FormControl('', [Validators.required, Validators.minLength(2)]),
      respuestasecreta: new FormControl('', Validators.required),
    });
  }

  private buildFormPreguntaSinExcepcion(): FormGroup {
    return new FormGroup({
      usuario: new FormControl('', Validators.required),
      twofactorcode: new FormControl('', [Validators.required, Validators.minLength(6)]),
    });
  }

  private buildFormDesbloqueaConExcepcion(): FormGroup {
    return new FormGroup({
      data: new FormControl('', Validators.required),
      usuario: new FormControl('', Validators.required),
      password: new FormControl('', Validators.required),
      password2: new FormControl('', Validators.required),
      pregunta: new FormControl('', Validators.required),
      respuesta: new FormControl('', [Validators.required, Validators.minLength(2)]),
    });
  }

  private buildFormDesbloqueaSinExcepcion(): FormGroup {
    return new FormGroup({
      data: new FormControl('', Validators.required),
      usuario: new FormControl('', Validators.required),
      password: new FormControl('', Validators.required),
      password2: new FormControl('', Validators.required),
    });
  }

  private mostrarError(mensaje: string): void {
    Swal.fire({
      title: 'Aviso',
      text: mensaje,
      icon: 'error',
    });
  }

  public async validarExcepcion(usuario: string, token: string = null) {
    return await firstValueFrom(this.authService.obtenerAlias(usuario, token == null ? '123sddsfewr' : token));
  }

  private async procesoPregunta(resp: IRespuestaObjeto) {
    
    const usuario = resp.Respuesta.find(item => item.startsWith("usuario:"));
    const pregunta = resp.Respuesta.find(item => item.startsWith("pregunta:"));
    if(!pregunta)this.mostrarError("El usuario no tiene ninguna pregunta de seguridad");
    const respuesta = resp.Respuesta.find(item => item.startsWith("respuesta:"));
    
    this.usuarioPrevio = usuario.split(":")[1];
    this.preguntaSecreta = pregunta.split(":")[1];
    this.respuestaSecreta = respuesta.split(":")[1];

    const promises: Promise<void>[] = [];
    [0, 1].map(async index => {
      if (index === 0) {
        promises.push(this.cargarCuenta());
      } else if (index === 1) {
        promises.push(this.cargarCatalogos());
      }
    });
    await Promise.all(promises);

    if (this.respuestaSecreta) this.formPregunta.patchValue({ respuestasecreta: this.respuestaSecreta });
    if (this.usuarioPrevio) this.formPregunta.patchValue({ usuario: this.usuarioPrevio });

    if (this.urlData) this.formDesbloqueaUsuario.patchValue({ data: this.urlData });
    if (this.usuarioPrevio) this.formDesbloqueaUsuario.patchValue({ usuario: this.usuarioPrevio });

  }

  private async procesoCodigo(resp: IRespuestaObjeto) {
    const usuario = resp.Respuesta.find(item => item.startsWith("usuario:"));
    this.usuarioPrevio = usuario.split(":")[1];

    const promises: Promise<void>[] = [];
    [0, 1].map(async index => {
      if (index === 0) {
        promises.push(this.cargarCuenta());
      } else if (index === 1) {
        promises.push(this.getCode());
      }
    });
    await Promise.all(promises);

    if (this.usuarioPrevio) this.formPregunta.patchValue({ usuario: this.usuarioPrevio });

    if (this.urlData) this.formDesbloqueaUsuario.patchValue({ data: this.urlData });
    if (this.usuarioPrevio) this.formDesbloqueaUsuario.patchValue({ usuario: this.usuarioPrevio });
  }

  public async getCode(): Promise<any> {
    try {
      const jsonParam = {
        Usuario: this.usuarioPrevio
      }
      const response: IResponse2FA = await this.authService.generarCodigoDesbloqueo(jsonParam).toPromise();
      if (response.datos.Intervalo > 0) {
        this.intervalo = 0;
        this.msgError = '';
        this.intervalo = response.datos.Intervalo;
        this.maskedEmail = response.datos.MaskedEmail;
        this.maskedPhone = response.datos.MaskedPhone;
        this.tiempoBloqueo = response.datos.TiempoBloqueo;
        this.intentos = response.datos.Intentos;
        this.startCountdown();
      }
      return response;
    } catch (error) {
      this.manejarError(error, 'Ocurrió un error al obtener el código.')
    }
  }

  startCountdown(): void {
    this.timer = setInterval(() => {
      this.intervalo--;

      if (this.intervalo <= 0) {
        clearInterval(this.timer);
        this.intervalo = 0;
        this.msgError = 'El código ha expirado. Por favor, solicita un nuevo código.';
      }
    }, 1000);
  }

  formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  }

  validarCodigo() {
    if (this.formPregunta.invalid) {
      return;
    }

    this.store.dispatch(ActivarLoadingAction());

    const jsonParam = {
      ...this.formPregunta.getRawValue()
    }

    this.authService.validarCodigoDesbloqueo(jsonParam).subscribe((resp: IResponse2FA) => {
      if (resp.validacion) {
        this.seccionA = false;
      }
    }, (error: HttpErrorResponse) => {
      Swal.fire({
        icon: 'error',
        title: error.error?.errorDescripcion,
      }).then(() => {
        this.formPregunta.get('twofactorcode').setValue('');
        this.store.dispatch(DesactivarLoadingAction());
      });
    }, () => {
      this.store.dispatch(DesactivarLoadingAction());
    });
  }

  public async newCode() {
    this.store.dispatch(ActivarLoadingAction());
    this.formPregunta.get('twofactorcode').setValue('');

    const promises: Promise<void>[] = [];
    [0].map(async index => {
      if (index === 0) {
        promises.push(this.getCode());
      }
    });

    await Promise.all(promises);
    this.store.dispatch(DesactivarLoadingAction());
  }

  private manejarError(error: any, mensajePorDefecto: string, temporalizador: number = 5000): void {
    let errorMessage: string;
    const errors = (error?.error.datos) ? error?.error.datos : [];
    if (errors?.length > 0) {
      errorMessage = errors.map((element: { Exception: any; }) => element.Exception).join('\n');
      Swal.fire({ icon: 'error', title: `${errorMessage}` });
    } else {
      Swal.fire({ icon: 'error', title: `${mensajePorDefecto}` });
    }
  }
}
